import { getRequest, patchRequest } from '@/plugins/api-axios'
import { getURL, authorizationBaseUrl } from '@/utils/axios'

import { deserialise, serialise } from 'kitsu-core'

const projectUserIncludeFull = 'user,displayContractor'

export async function searchProjectUsers(filters: any = {}, include = projectUserIncludeFull) {
    let { data } = await getRequest(
        getURL({
            path: `projectUsers`,
            base: authorizationBaseUrl,
            params: {
                include,
                ...filters,
            },
        })
    )

    return deserialise(data).data
}

const companyAdminIncludeFull = 'company,user'

export async function searchCompanyAdmin(filters: any = {}, include = projectUserIncludeFull) {
    let { data } = await getRequest(
        getURL({
            path: `companyAdmins`,
            base: authorizationBaseUrl,
            params: {
                include,
                ...filters,
            },
        })
    )

    return deserialise(data).data
}
